"use client";
import cn from "classnames";
import { usePathname } from "next/navigation";
import LanguageSelector from "@/components/common/LanguageSelector";
import { LanguageSelectorVariant } from "@/components/common/LanguageSelector/constants";
import { createLocalizedPathList } from "@/components/common/LanguageSelector/utils/createLocalizedPathList";
import { type SiteLocales } from "@/types/site-options";
import s from "./LanguageSwitcher.module.scss";

export interface LanguageSwitcherProps {
  locales: SiteLocales;
  localeSegmentIndex: number;
  variant?: LanguageSelectorVariant;
}

export default function LanguageSwitcher(props: LanguageSwitcherProps) {
  const {
    locales: { primary: primaryLocale, secondary: secondaryLocales },
    localeSegmentIndex,
    variant = LanguageSelectorVariant.Button,
  } = props;
  const pathname = usePathname();
  const activeSecondaryLocales = secondaryLocales
    .filter((locale) => locale.live)
    .map((item) => item.locale);
  const localizedPathList = createLocalizedPathList(
    pathname,
    primaryLocale,
    activeSecondaryLocales,
    localeSegmentIndex,
  );

  if (localizedPathList.length <= 1) {
    return null;
  }

  return (
    <div
      className={cn(s.wrapper, {
        [s.buttonVariant]: variant === LanguageSelectorVariant.Button,
        [s.dropdownVariant]: variant === LanguageSelectorVariant.Dropdown,
      })}
    >
      <LanguageSelector list={localizedPathList} variant={variant} />
    </div>
  );
}
